module.exports = __webpack_public_path__ + "media/users/images/reset-password-icon-e545aa473f6a3a67ac01dcb035cb921f.svg";